import api from './api';

export const serviceOrderService = {
  /**
   * Obtener todas las órdenes de servicio
   */
  async getServiceOrders(params = {}) {
    try {
      console.log('📡 [serviceOrderService] Enviando petición GET a:', '/api/service-orders');
      console.log('📋 [serviceOrderService] Parámetros:', params);
      
      const response = await api.get('/service-orders', { params });
      
      console.log('✅ [serviceOrderService] Respuesta recibida exitosamente');
      console.log('📦 [serviceOrderService] Response.data:', response.data);
      console.log('🔢 [serviceOrderService] Cantidad de órdenes:', Array.isArray(response.data?.data) ? response.data.data.length : 'No es un array');
      
      return response.data;
    } catch (error) {
      console.error('❌ [serviceOrderService] Error al obtener órdenes de servicio:', error);
      console.error('📊 [serviceOrderService] Error.response:', error.response);
      console.error('📋 [serviceOrderService] Error.response?.data:', error.response?.data);
      throw error;
    }
  },

  /**
   * Obtener una orden de servicio por ID
   */
  async getServiceOrder(id) {
    try {
      const response = await api.get(`/service-orders/${id}`);
      return response.data;
    } catch (error) {
      console.error('Error al obtener orden de servicio:', error);
      throw error;
    }
  },

  /**
   * Crear una nueva orden de servicio
   */
  async createServiceOrder(orderData) {
    try {
      console.log('📡 [serviceOrderService] Enviando petición POST a:', '/api/service-orders');
      console.log('📋 [serviceOrderService] Datos de la orden:', orderData);
      console.log('📊 [serviceOrderService] Cantidad de items:', orderData.items?.length || 0);
      
      const response = await api.post('/service-orders', orderData);
      
      console.log('✅ [serviceOrderService] Orden de servicio creada exitosamente');
      console.log('📦 [serviceOrderService] Response.data:', response.data);
      console.log('🆔 [serviceOrderService] ID de orden creada:', response.data?.data?.id);
      console.log('🔖 [serviceOrderService] Código de orden:', response.data?.data?.code);
      
      return response.data;
    } catch (error) {
      console.error('❌ [serviceOrderService] Error al crear orden de servicio:', error);
      console.error('📊 [serviceOrderService] Error.response:', error.response);
      console.error('📋 [serviceOrderService] Error.response?.data:', error.response?.data);
      throw error;
    }
  },

  /**
   * Actualizar una orden de servicio
   */
  async updateServiceOrder(id, orderData) {
    try {
      console.log('📡 [serviceOrderService] Enviando petición PUT a:', `/api/service-orders/${id}`);
      console.log('🆔 [serviceOrderService] ID de orden:', id);
      console.log('📋 [serviceOrderService] Datos de la orden:', orderData);
      
      const response = await api.put(`/service-orders/${id}`, orderData);
      
      console.log('✅ [serviceOrderService] Orden de servicio actualizada exitosamente');
      console.log('📦 [serviceOrderService] Response.data:', response.data);
      
      return response.data;
    } catch (error) {
      console.error('❌ [serviceOrderService] Error al actualizar orden de servicio:', error);
      console.error('📊 [serviceOrderService] Error.response:', error.response);
      throw error;
    }
  },

  /**
   * Obtener todos los datos del formulario de orden de servicio en una sola petición.
   * Incluye: proveedores, servicios (adquisición) y proyectos.
   */
  async getFormData() {
    try {
      const response = await api.get('/service-orders/form-data');
      return response.data;
    } catch (error) {
      console.error('Error al obtener datos del formulario de orden de servicio:', error);
      throw error;
    }
  },

  /**
   * Cancelar o reactivar una orden de servicio (toggle)
   */
  async toggleServiceOrderStatus(id) {
    try {
      console.log('📡 [serviceOrderService] Enviando petición DELETE a:', `/api/service-orders/${id}`);
      console.log('🆔 [serviceOrderService] ID de orden a cambiar estado:', id);
      
      const response = await api.delete(`/service-orders/${id}`);
      
      console.log('✅ [serviceOrderService] Estado de orden cambiado exitosamente');
      console.log('📦 [serviceOrderService] Response.data:', response.data);
      
      return response.data;
    } catch (error) {
      console.error('❌ [serviceOrderService] Error al cambiar estado de orden:', error);
      console.error('📊 [serviceOrderService] Error.response:', error.response);
      throw error;
    }
  },
};



